import { render, staticRenderFns } from "./UserMailInfo.vue?vue&type=template&id=e1457afc"
import script from "./UserMailInfo.vue?vue&type=script&lang=js"
export * from "./UserMailInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports